export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11793.17f648dd.jpg";